var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"featured-event"},[_c('div',{staticClass:"container"},[_c('h2',{attrs:{"id":"carousel-heading"}},[_vm._v("Featured Event")]),_vm._v(" "),_c('EventCard',{attrs:{"event":_vm.event,"show-description":true}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }